<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" :title="title" fullscreen>
      <el-card class="ml-card">
        <el-form ref="elForm" :label-position="labelPosition" label-width="80px" :model="formData">
          <el-form-item label="客户名称">
            <span>{{ formData.customer_name }}</span>
          </el-form-item>
          <el-form-item label="销售名称">
            <span>{{ formData.sale_name }}</span>
          </el-form-item>
          <el-form-item label="跟进时间">
            <el-date-picker
                v-model="formData.follow_at"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                default-time="12:00:00"
                placeholder="选择跟进时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="跟进情况">
            <el-input v-model="formData.report" type="textarea" placeholder="请输入跟进情况" :rows="10" maxlength="500"
                      show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleConfirm" :loading="submitLoading" :disabled="submitLoading">
              {{ submitLoading ? '提交中...' : '保存' }}
            </el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="ml-card">
        <div class="default-table">
          <el-link type="primary" @click="handleQuery">
            <i :class="[loading?'el-icon-loading':'el-icon-refresh']"/>
            历史跟进记录(双击行，可进行修改操作)
          </el-link>
          <el-table :data="datalist" @row-dblclick="dblclickEvent" highlight-current-row border>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="sale_name" label="跟进销售" align="center" width="100"></el-table-column>
            <el-table-column prop="follow_at" label="跟进时间" align="center" width="140"></el-table-column>
            <el-table-column prop="report" label="跟进情况" align="left" header-align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="created_at" label="创建时间" align="center" width="140"></el-table-column>
            <el-table-column prop="updated_at" label="修改时间" align="center" width="140"></el-table-column>
            <el-table-column label="操作项" align="center" width="140">
              <template slot-scope="{row,$index}">
                <el-link type="primary" icon="el-icon-edit" @click="handlerEdit(row)">修改</el-link> &nbsp;&nbsp;
                <el-link type="primary" icon="el-icon-delete" @click="handlerDelete(row,$index)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div>
          <Pagination
              v-show="total>0"
              :total="total"
              :page.sync="query.page"
              :limit.sync="query.per_page"
              @pagination="handleQuery"
              :page-sizes="[3,5,10,15]"
          />
        </div>
      </el-card>

    </el-dialog>
  </div>
</template>

<script>
import {
  customerFollowRecordDelete,
  getCustomerFollowRecordList,
  customerFollowRecordStore,
  getCustomerRecordInfo,
} from "../../api/customerPool";

export default {
  name: "AddTaskRecord",
  inheritAttrs: false,
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      submitLoading: false,//提交中
      // title: '添加客户记录',
      customerName: null,
      rules: {},
      labelPosition: 'right',
      formData: {
        info_id: null,
        customer_id: null,
        customer_name: null,
        sale_id: null,
        sale_name: null,
        follow_at: null,
        report: null,
      },
      loading: false,
      datalist: [],
      total: 0,
      query: {page: 1, per_page: 10, info_id: null, orderBy: "`id` desc"}
    }
  },
  computed: {
    title() {
      return this.formData.id ? `[修改]客户【${this.formData.customer_name}】跟进记录（ID:${this.formData.id}）` : `[添加]客户【${this.formData.customer_name}】跟进记录`
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    onOpen() {
      this.query.info_id = this.id
      this.getInfo()
      this.handleQuery()
    },
    onClose() {
      this.$refs['elForm'].resetFields()
      this.resetForm()
    },
    close() {
      this.$emit('update:visible', false)
    },
    handleConfirm() {
      this.$refs['elForm'].validate(valid => {
        if (!valid) return
        this.submitLoading = true
        // eslint-disable-next-line
        customerFollowRecordStore(this.formData).then(res => {
          setTimeout(() => {
            this.submitLoading = false
          }, 1000)
          const data = res.data || {}
          if (data.id) {
            this.msgSuccess(res.message || '未知操作')
            this.formData.report=''
            this.formData.follow_at=''
            this.handleQuery()
          }
        })
        // this.close()
      })
    },
    resetForm() {

      this.formData = {
        info_id: null,
        customer_id: null,
        customer_name: null,
        sale_id: null,
        sale_name: null,
        follow_at: null,
        report: null,
      }
      this.getInfo()
      // this.$refs[formName].resetFields();
    },
    getInfo() {
      getCustomerRecordInfo({id: this.id}).then((res) => {
        let data = res.data || {}
        let info = data.info || {}
        this.formData.info_id = info.id
        this.formData.customer_id = info.customer_id
        this.formData.customer_name = info.customer_name
        this.formData.sale_id = info.sale_id
        this.formData.sale_name = info.sale_name
      })
    },
    handleQuery() {
      this.loading = true
      this.query.info_id = this.id
      getCustomerFollowRecordList(this.query).then(res => {
        const data = res.data || {}
        this.datalist = data.list || []
        this.query.page = data.current_page
        this.query.per_page = data.per_page
        this.total = data.total
        this.loading = false
      })
    },
    handlerEdit(row) {
      delete row.created_at;
      delete row.updated_at;
      delete row.deleted_at;
      this.formData = Object.assign({}, row)
    },
    dblclickEvent(row) {
      this.handlerEdit(row)
    },
    handlerDelete(row, $index) {
      this.$msgbox.confirm('确认删除跟进记录', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //调用删除方法
        customerFollowRecordDelete({id: row.id}).then(res => {
          if (res)
            this.datalist.splice($index, 1)
        })
      })

    }
  }
}
</script>

<style scoped>
.ml-card {
  max-width: 1200px;
  width: 1200px;
  margin: 10px auto;
  padding: 10px;
}
</style>
